// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import DocumentosPage from './components/DocumentosPage';

const App = () => {
  // Função para verificar se o usuário está autenticado
  const isAutenticado = () => {
    const token = localStorage.getItem('token');
    return !!token;
  };

  // Componente de rota protegida
  const RotaProtegida = ({ children }) => {
    return isAutenticado() ? children : <Navigate to="/login" />;
  };

  return (
    <Router>
      <Routes>
        {/* <Route path="/login" element={<LoginPage />} /> */}
        <Route path="/login/:cnpj?/:codigo?" element={<LoginPage />} />
        <Route
          path="/documentos"
          element={
            <RotaProtegida>
              <DocumentosPage />
            </RotaProtegida>
          }
        />
        <Route path="/" element={<Navigate to="/documentos" />} />
        <Route path="*" element={<Navigate to="/documentos" />} />
      </Routes>
    </Router>
  );
};

export default App;